export default __webpack_public_path__ + "static/philippines-e26130cc53b62da0cd2aaa5091a5f1e0.svg";